import { getEnv } from '~/utils';

const EnvBadge = () => {
  const rawDomain = import.meta.env.VITE_APP_OLD_DOMAIN;
  if (!rawDomain) return null;

  const domain = getEnv(rawDomain);
  if (domain === 'https://old.nuimarkets.com') return null;

  const server = domain
    .replace('https://', '')
    .replace('.cream.global', '')
    .toUpperCase();

  return (
    <div
      className="tw tw:md:absolute tw:left-1/2 tw:md:-translate-x-1/2 tw:px-20 tw:z-50 tw:md:rounded-b-sm tw:bg-purple-700 tw:text-white tw:h-5 tw:flex tw:items-center tw:justify-center tw:text-xs tw:font-semibold tw:whitespace-nowrap tw:-mx-2 tw:md:mx-0"
      data-testid="env-badge"
    >
      {server} SERVER
    </div>
  );
};

export default EnvBadge;
